import { render, staticRenderFns } from "./outlets.vue?vue&type=template&id=66f57d20&"
import script from "./outlets.vue?vue&type=script&lang=js&"
export * from "./outlets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports